import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Update a team member's permissions
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestEditTeamMember = packet => {
  return {
    type: 'REQUEST_EDIT_TEAM_MEMBER',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveEditTeamMemberSuccess = data => ({
  type: 'RECEIVE_EDIT_TEAM_MEMBER_SUCCESS',
  data
})

export const receiveEditTeamMemberFail = data => ({
  type: 'RECEIVE_EDIT_TEAM_MEMBER_FAIL',
  data
})

export const tryToEditTeamMember = packet => (dispatch, getState) => {


  dispatch(requestEditTeamMember(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/members/' + packet.kind + '/' + packet.id + '/' + packet.member.id, {
      method: 'put',
      body: JSON.stringify(packet.member),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveEditTeamMemberSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveEditTeamMemberFail({errors:e, lastSubmit: packet}));
    })
}
